/**
 * DatePicker Component - Template
 * ===============================
 */

export const DATE_PICKER_TEMPLATE: string = `
<div class="ec-date-picker" ng-class="$ctrl.getWrapperClasses()">
  <label ng-if="$ctrl.label || $ctrl.hasLabelSlot" ng-attr-id="{{ $ctrl.labelId }}" ng-class="$ctrl.getLabelClasses()"><span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span><span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span></label>

  <div ng-class="$ctrl.getRelativeClasses()" ng-keydown="$ctrl.handleKeydown($event)">
    <button
      type="button"
      ng-class="$ctrl.getTriggerClasses()"
      ng-click="$ctrl.toggle($event)"
      ng-disabled="$ctrl.disabled"
      aria-haspopup="dialog"
      ng-attr-aria-expanded="{{ $ctrl.open ? 'true' : 'false' }}"
      ng-attr-aria-labelledby="{{ ($ctrl.label || $ctrl.hasLabelSlot) ? $ctrl.labelId : undefined }}"
      ng-attr-aria-label="{{ (!$ctrl.label && !$ctrl.hasLabelSlot) ? $ctrl.ariaLabel : undefined }}"
    >
      <span ng-if="$ctrl.displayText" ng-class="$ctrl.getTriggerTextClasses()">{{ $ctrl.displayText }}</span>
      <span ng-if="!$ctrl.displayText" ng-class="$ctrl.getPlaceholderClasses()">{{ $ctrl.placeholder }}</span>
      <span ng-class="$ctrl.getChevronClasses()" ng-bind-html="$ctrl.trustedChevron" aria-hidden="true"></span>
    </button>

    <div ng-if="$ctrl.open" ng-class="$ctrl.getPanelClasses()" role="dialog" aria-modal="false" aria-label="Calendario">
      <div ng-class="$ctrl.getHeaderClasses()">
        <button type="button" ng-class="$ctrl.getNavClasses()" ng-click="$ctrl.prevMonth($event)" aria-label="Mes anterior">
          <span ng-class="$ctrl.getNavIconClasses()" ng-bind-html="$ctrl.trustedPrev" aria-hidden="true"></span>
        </button>
        <div ng-class="$ctrl.getMonthYearClasses()" aria-live="polite" ng-attr-aria-label="{{ $ctrl.monthLabel }}">
          <span ng-class="$ctrl.getMonthLabelClasses()">{{ $ctrl.monthName }}</span>
          <span ng-class="$ctrl.getNavIconClasses()" ng-bind-html="$ctrl.trustedNext" aria-hidden="true"></span>
          <span ng-class="$ctrl.getMonthLabelClasses()">{{ $ctrl.yearLabel }}</span>
        </div>
        <button type="button" ng-class="$ctrl.getNavClasses()" ng-click="$ctrl.nextMonth($event)" aria-label="Mes siguiente">
          <span ng-class="$ctrl.getNavIconClasses()" ng-bind-html="$ctrl.trustedNext" aria-hidden="true"></span>
        </button>
      </div>

      <div ng-class="$ctrl.getWeekRowClasses()">
        <span ng-repeat="wd in $ctrl.weekdays track by $index" ng-class="$ctrl.getWeekdayClasses()">{{ wd }}</span>
      </div>

      <div ng-class="$ctrl.getGridClasses()">
        <div
          ng-repeat="cell in $ctrl.days track by $index"
          ng-class="$ctrl.getDayClasses(cell)"
          ng-click="$ctrl.selectDay(cell, $event)"
          ng-attr-role="{{ cell.day ? 'button' : undefined }}"
          ng-attr-aria-label="{{ cell.day ? ($ctrl.dayAriaLabel(cell)) : undefined }}"
          ng-attr-aria-selected="{{ cell.day && $ctrl.isSelected(cell) ? 'true' : undefined }}"
        >
          <span ng-if="cell.day">{{ cell.day }}</span>
        </div>
      </div>
    </div>
  </div>

  <span ng-if="$ctrl.helpMessage || $ctrl.hasHelpSlot" ng-class="$ctrl.getHelpClasses()"><span ng-if="$ctrl.hasHelpSlot" ng-transclude="helpSlot"></span><span ng-if="!$ctrl.hasHelpSlot">{{ $ctrl.helpMessage }}</span></span>
</div>
`;

export default DATE_PICKER_TEMPLATE;
